import { gql } from "@grandvisionhq/graphql";
import StoreByIdFragment from "../../../fragments/operations/fragments/store-by-id.js";
const GET_STORE_BY_ID = gql`
  query GetStoreById($globalStoreId: ID) {
    store(globalStoreId: $globalStoreId) {
      ...StoreById
    }
  }
  ${StoreByIdFragment}
`;
export {
  GET_STORE_BY_ID
};
//# sourceMappingURL=get-store-by-id.js.map
